<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kullanıcı Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Güncellenecek e-posta adresi veya kullanıcı adı
                benzersiz olmalıdır...</span
              >
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Kullanıcı Güncelleme Formu">
            <b-row>
              <b-col md="12">
                <b-form-group label="Kullanıcı Rolü" label-for="role">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Soru"
                  >
                    <v-select
                      id="roles"
                      v-model="selectedRole"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="roles"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="selectedRole.role == 'pollster'">
              <b-col md="12">
                <b-form-group label="Kullanıcı Adı" label-for="username">
                  <validation-provider
                    #default="{ errors }"
                    vid="username"
                    :rules="{ required: selectedRole.role == 'pollster' ? true : false }"
                    name="Kullanıcı Adı"
                  >
                    <b-form-input
                      id="username"
                      type="text"
                      v-model="username"
                      placeholder="Kullanıcı Adı"
                      :state="errors.length > 0 ? false : null"
                      @keyup="usernameKeyup"
                    />

                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              v-if="selectedRole.role == 'admin' || selectedRole.role == 'stock-manager'"
            >
              <b-col cols="12">
                <b-form-group label="E-Posta" label-for="email">
                  <validation-provider
                    #default="{ errors }"
                    vid="email"
                    :rules="{
                      required:
                        selectedRole.role == 'admin' ||
                        selectedRole.role == 'stock-manager'
                          ? true
                          : false,
                      email: true,
                    }"
                    name="E-Posta"
                  >
                    <b-form-input
                      id="email"
                      type="email"
                      v-model="email"
                      placeholder="E-Posta"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="selectedRole.role == 'stock-manager'">
              <b-col md="12">
                <b-form-group label="Hava Limanları" label-for="airports">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Hava Limanları"
                  >
                    <v-select
                      id="airports"
                      v-model="selectedAirports"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="airports"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div>
                  <b-button
                    class="float-right"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    v-on:click="addAllAirports"
                  >
                    Tümünü Ekle
                  </b-button>
                  <b-button
                    class="float-right mr-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    v-on:click="removeAllAirports"
                  >
                    Tümünü Kaldır
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Ad Soyad" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    vid="name"
                    :rules="{ required: true }"
                    name="Ad Soyad"
                  >
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="name"
                      placeholder="Ad Soyad"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false, false)"
                  >
                    <b-spinner v-if="spinner === true" small />
                    {{ spinner === true ? "Kaydediliyor" : "Kaydet" }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import {
  BPagination,
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
  BBadge,
  BInputGroupAppend,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
const endpoints = new Endpoints();

export default {
  components: {
    BPagination,
    BBadge,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    BInputGroupAppend,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
     id: this.$route.params.idParam,
      name: "",
      user: {},
      email: "",
      username: "",
      spinner: false,
      baseUrl: settings.apiBaseUrl,
      request: [],
      airports: [],
      airportIds: null,
      selectedAirports: [],
      roles: [
        {
          name: "Yönetici",
          role: "admin",
        },
        {
          name: "Anketör",
          role: "pollster",
        },
        {
          name: "Stok Görevlisi",
          role: "stock-manager",
        },
      ],
      selectedRole: "",
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal) {
        this.getUsers(newVal);
      },
      deep: true,
    },
  },
  methods: {
    usernameKeyup() {
      this.username = this.username
        .replace(/[^a-zA-Z0-9]/g, "")
        .split(" ")
        .join("")
        .trim()
        .toLowerCase();
    },

    getUserById() {
      endpoints
      .getUserById(this.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.user = data.response;
          this.name = this.user.name;
          this.email = this.user.email;
          this.username = this.user.username;
          this.selectedRole = this.roles.find((item) => item.role == this.user.role);
          this.selectedAirports = this.user.airportIds.map((item) => {
            return this.airports.find((airport) => airport.id == item);
          });
       
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addAllAirports() {
      this.selectedAirports = [...this.airports];
    },
    removeAllAirports() {
      this.selectedAirports = [];
    },
    getAllAirports() {
      endpoints
        .getAllAirports(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.airports = [...data.response];
          this.getUserById();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText() {
      this.$swal({
        title: "Kayıt?",
        text: "Kullanıcıyı güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          if (
            this.selectedRole.role == "admin" ||
            this.selectedRole.role == "stock-manager"
          ) {
            this.username = null;
          } else {
            this.email = null;
          }

          if (this.selectedRole.role == "stock-manager") {
            this.airportIds = this.selectedAirports.map((item) => item.id);
          } else {
            this.airportIds = null;
          }

          let data = {
            id: this.id,
            name: this.name,
            role: this.selectedRole.role,
            email: this.email,
            username: this.username,
            airportIds: this.airportIds,
          };
          endpoints
            .putUsers(data, this.$i18n.locale, () => {})
            .then((data) => {
              this.spinner = false;

              if (!data.status) {
                this.$swal({
                  icon: "error",
                  title: "Hata!",
                  text: "Kullanıcı zaten kayıtlı.",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {});
              } else {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Kullanıcı güncellendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {});
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    }
  },
  mounted() {

    this.getAllAirports();
    this.selectedRole = this.roles[0];
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
